var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNewPictureIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    rx: 10,
    fill: "#FEFBF2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9167 41.25C15.0458 41.25 14.3006 40.9402 13.681 40.3206C13.0614 39.701 12.7511 38.9552 12.75 38.0833V15.9167C12.75 15.0458 13.0603 14.3006 13.681 13.681C14.3017 13.0614 15.0469 12.7511 15.9167 12.75H38.0833C38.9542 12.75 39.6999 13.0603 40.3206 13.681C40.9413 14.3017 41.2511 15.0469 41.25 15.9167V38.0833C41.25 38.9542 40.9402 39.6999 40.3206 40.3206C39.701 40.9413 38.9552 41.2511 38.0833 41.25H15.9167ZM19.0833 34.9167H34.9167C35.2333 34.9167 35.4708 34.7715 35.6292 34.4813C35.7875 34.191 35.7611 33.9139 35.55 33.65L31.1958 27.8313C31.0375 27.6201 30.8264 27.5146 30.5625 27.5146C30.2986 27.5146 30.0875 27.6201 29.9292 27.8313L25.8125 33.3333L22.8833 29.4146C22.725 29.2035 22.5139 29.0979 22.25 29.0979C21.9861 29.0979 21.775 29.2035 21.6167 29.4146L18.45 33.65C18.2389 33.9139 18.2125 34.191 18.3708 34.4813C18.5292 34.7715 18.7667 34.9167 19.0833 34.9167Z",
    fill: "#FFD336"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPictureIcon);
export default __webpack_public_path__ + "static/media/new-picture-icon.575e6fb23928af7f0658e465e33da9d3.svg";
export { ForwardRef as ReactComponent };